import React, { useState } from 'react'
import { connect } from 'react-redux'
import ActionLinks from '../ActionLinks/ActionLinks'
import { MISSION_STATUS_ENUM } from '../../shared/constants'
import { authorization } from '../../Module/Auth/Auth'
import { UNBOOK_OPTIONS } from '../../constants'
import { SelectDashboard } from '../Form/SelectDashboard'
import { showReduxModal } from '../../Reducers/UI/actions'
import {
  getShowDeleteAllNonStartedModalText,
  onPublishDraftMissions,
} from './utils'
import { apiClient } from '../../Module/API/Client'

const NON_STARTED_STATUSES = [
  MISSION_STATUS_ENUM.DRAFT,
  MISSION_STATUS_ENUM.AVAILABLE,
  MISSION_STATUS_ENUM.BOOKED,
]

const MissionsControls = props => {
  const {
    missions,
    campaign,
    updateData,
    // Redux
    showReduxModal,
  } = props

  const [unbookReason, setUnbookReason] = useState(UNBOOK_OPTIONS[0].value)

  const getActionLinks = () => {
    if (!authorization.isCityManager()) return []
    let actionLinks = []

    const hasDraftMissions = missions.some(
      mission => mission.status === MISSION_STATUS_ENUM.DRAFT,
    )

    const hasNonStartedMissions = missions.some(mission =>
      NON_STARTED_STATUSES.includes(mission.status),
    )

    if (hasDraftMissions) {
      actionLinks.push({
        label: 'Publish all draft missions',
        action: () =>
          onPublishDraftMissions({
            campaign,
            missions,
            showReduxModal,
            updateData,
          }),
      })
    }

    if (hasNonStartedMissions) {
      actionLinks.push({
        label: 'Delete ALL non-started missions',
        action: deleteAllNonStartedMissions,
      })
    }

    return actionLinks
  }

  const deleteAllNonStartedMissions = () => {
    const isAnyBooked = missions.find(
      mission => mission.status === MISSION_STATUS_ENUM.BOOKED,
    )

    const onReasonChange = (e, index, value) => {
      setUnbookReason(value)
    }

    const { nonStartedMissionsIds, missionsSpyCheckedInIds } = missions.reduce(
      (acc, mission) => {
        if (NON_STARTED_STATUSES.includes(mission.status)) {
          if (
            mission.spyInformation &&
            mission.spyInformation.spyDetails &&
            mission.spyInformation.spyDetails.checkInTime
          ) {
            acc.missionsSpyCheckedInIds.push({ id: Number(mission.id) })
          } else {
            acc.nonStartedMissionsIds.push({ id: Number(mission.id) })
          }
        }
        return acc
      },
      { nonStartedMissionsIds: [], missionsSpyCheckedInIds: [] },
    )

    if (!nonStartedMissionsIds.length && !missionsSpyCheckedInIds.length) {
      return showReduxModal({
        title: 'There is 0 non-started missions that can be deleted',
        confirmLabel: 'OK',
        hideCancel: true,
      })
    }

    const infoText = getShowDeleteAllNonStartedModalText(
      isAnyBooked,
      missionsSpyCheckedInIds,
    )

    return showReduxModal({
      children: isAnyBooked && (
        <div>
          {infoText}
          <SelectDashboard
            label={'Reason:'}
            input={{ name: 'unbookMission', value: unbookReason }}
            options={UNBOOK_OPTIONS}
            onChange={onReasonChange}
          />
        </div>
      ),
      onConfirm: async () => {
        const payload = {
          unbookReason: unbookReason,
          missions: nonStartedMissionsIds,
        }

        await apiClient.deleteMissions(payload)
        updateData()
      },
      title: `Delete ${nonStartedMissionsIds.length} non-started missions`,
      cancelLabel: 'Cancel',
      confirmLabel: 'Delete All',
    })
  }

  return <ActionLinks items={getActionLinks()} />
}

const mapDispatchToProps = {
  showReduxModal,
}

export default connect(
  null,
  mapDispatchToProps,
)(MissionsControls)



// WEBPACK FOOTER //
// ./src/Components/MissionsControls/MissionsControls.js